import { Row, Col } from 'react-bootstrap';
import {useState, useEffect} from 'react';
import Card  from '../../ui/Card';
import SearchResultContainer from './searchResultContainer';
import { useForm } from 'react-hook-form';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Spinner from 'react-bootstrap/Spinner';
import swal from 'sweetalert';
import BaseService from '../../../services/BaseService';
import SecurityContainer from '../securityContainer';

const FinalSaleUpdate = (props) => {
    const [showSearchResult, setShowSearchResult] = useState(false);
    const { handleSubmit} = useForm();
    const [isLoading, setIsLoading] = useState(true);
    const [cdiacNumbers, setCdiacNumbers] = useState([]);
    const [finalSaleId, setFinalSaleId] = useState("");
    
    const handleCdiacChange = (e, key) => {
      setFinalSaleId(e.length > 0 ? e[0][key] : '')
    }

    const onSubmit = (data) => {
        if(finalSaleId === '') {
          var name = 'Please select cdiac number !';
          var content = document.createElement('div');
          content.innerHTML = '<strong>'+ name +'</strong>';
          swal(content);
          return;
        }
        setShowSearchResult(true);
    }

    useEffect(() => {
      getCdiacNumbers()
    }, []);

    const getCdiacNumbers = () => {
      //Get Cdiac Numbers   
      var obj = {
        msgId: null,
        sysId: null,
        opr: "getCdiacFinalSale",
        hdrStruct: null,
        queryParam: null,
        reqData: {
          "updateType": "FinalSale"
         },
      };
  
      BaseService.processRequest(obj)
        .then((res) => res)
        .then((result) => {
          Object.keys(result.data.responses).forEach((key) => {
              setCdiacNumbers(result.data.responses[key]);
          });
          setIsLoading(false);
        });
    }

    return (
        <SecurityContainer>
        <form onSubmit={(e) => e.preventDefault()}>
        <Card>
          <div className="panel panel-default">
              <div className="panel-heading">
                <div className="container">
                    <div id="packet_id" className="panel-title">
                        <h1 className="menu-title">Report of Final Sale Update</h1>
                        
                    </div>
                </div>
              </div>
              <div className="panel-body">
                <div className="container">
                  <div className="form">
                  {isLoading && <Spinner animation="border" variant="primary" />}
                  <Row>
                    <Col>
                      <div className="control">
                          <label>CDIAC Number: </label>
                          <Typeahead
                            placeholder="Choose CDIAC Number"
                            id="finalsale"
                            labelKey="cdiacNumber"
                            onChange={e=>handleCdiacChange(e, "finalSaleId")}
                            inputProps={{ 'data-validations': 'required', name: 'cdiacNumber' }}
                            options={cdiacNumbers}
                          />
                      </div>
                    </Col>
                  </Row>
                  
                  <div style={{overflow: 'auto'}}>
                    <div className="fleft">
                      <a href="/admin" className="dk-blue-color link-button">Back to Admin</a>
                    </div>
                    <button style={{float: 'right', marginBottom: '0'}} className="custom-button" type="Submit" onClick={handleSubmit(onSubmit)}>Search</button>
                  </div>
                  </div>
                </div>
              </div>
          </div>
          {showSearchResult && <SearchResultContainer finalSaleId={finalSaleId} />}         
           
        </Card>
        </form>
        </SecurityContainer>
    )
}

export default FinalSaleUpdate
